import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Result, Spin, Typography } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { v2Api } from '../../services/v2';
import { asV2Error } from '../../utils/v2';

type RouteParams = { token: string };

const UnsubscribePage = ({ match }: RouteComponentProps<RouteParams>) => {
    const token = match.params.token;
    const [status, setStatus] = useState<string>();
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        let active = true;
        v2Api.unsubscribeState(token)
            .then((result) => {
                if (active) setStatus(result.status);
            })
            .catch((nextError) => {
                if (active) setError(asV2Error(nextError).message);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [token]);

    const confirm = async () => {
        setSubmitting(true);
        setError(undefined);
        try {
            const result = await v2Api.unsubscribe(token);
            setStatus(result.status);
        } catch (nextError) {
            setError(asV2Error(nextError).message);
        } finally {
            setSubmitting(false);
        }
    };

    const completed = status === 'UNSUBSCRIBED' || status === 'USED';
    const invalid = status === 'INVALID' || status === 'EXPIRED' || status === 'REVOKED';

    return (
        <main className="mail-unsubscribe-page">
            <Card className="mail-unsubscribe-card" bordered={false}>
                {loading ? (
                    <div className="mail-unsubscribe-loading"><Spin tip="正在验证退订链接…" /></div>
                ) : completed ? (
                    <Result
                        status="success"
                        title="已停止营销邮件"
                        subTitle="该退订请求已经生效。系统不会再向此地址发送自动营销邮件。"
                    />
                ) : invalid ? (
                    <Result
                        status="warning"
                        title="退订链接已失效"
                        subTitle="链接可能已过期或不可用。如仍收到邮件，请联系邮件中的发件方。"
                    />
                ) : (
                    <>
                        <Typography.Title level={2}>停止接收营销邮件</Typography.Title>
                        <Typography.Paragraph>
                            确认后，本邮箱将不再接收 SynRay Consulting 的自动营销邮件。该操作不影响必要的业务或服务通知。
                        </Typography.Paragraph>
                        {error && <Alert className="mail-inline-alert" type="error" showIcon message={error} />}
                        <Button type="primary" danger size="large" loading={submitting} onClick={confirm}>
                            确认退订
                        </Button>
                    </>
                )}
                {!loading && error && (completed || invalid) && (
                    <Alert className="mail-inline-alert" type="error" showIcon message={error} />
                )}
            </Card>
        </main>
    );
};

export default UnsubscribePage;
